/**
 * Optional in-memory / portal-backed storage override (YouTube Playables full-save sync).
 * When set, all storage helpers route here instead of localStorage.
 */

/** @type {Storage | null} */
var gameStorageOverride = null;

/**
 * @param {Storage | null} storage
 */
export function setGameStorageOverride(storage) {
  gameStorageOverride = storage;
}

export function clearGameStorageOverride() {
  gameStorageOverride = null;
}

export function hasGameStorageOverride() {
  return !!gameStorageOverride;
}

/**
 * @param {Storage | null | undefined} explicit
 * @returns {Storage | null}
 */
export function resolveGameStorage(explicit) {
  if (gameStorageOverride) return gameStorageOverride;
  if (explicit != null) return explicit;
  return typeof localStorage !== "undefined" ? localStorage : null;
}
